import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col, Button, Collapse } from 'react-bootstrap';
import { translate } from 'react-i18next';
import MainLogin from '../../components/MainLogin';

import ServiceInfoBox from '../../components/ServiceInfoBox';
import RootOptionGroup from '../../components/RootOptionGroup';
import LanguageSelector from '../../components/LanguageSelector';
import InnerHtmlContent from '../../components/InnerHtmlContent';

class RootSelection extends Component {

  constructor(props) {
    super(props);
    this.getPathsAsOptions = this.getPathsAsOptions.bind(this);
    this.select = this.select.bind(this);
    if (props.goTo) {
      const { goTo, options } = this.props;
      const path = options.find(opt => opt.pathType === goTo);
      if (path) {
        this.select(path.id);
      }
    }
  }

  getPathsAsOptions(options, viaSso) {
    return options.filter((option) => {
      const { requiresSSO } = option;
      if (!requiresSSO) {
        return true;
      }
      return requiresSSO && viaSso;
    });
  }

  select(selectionId) {
    const { options, pathSelected, googleAnalyticsTrackingId } = this.props;
    if (selectionId !== pathSelected) {
      const path = Object.assign(
        options.find(r => r.id === selectionId),
        { googleAnalyticsTrackingId }
      );
      this.props.loadPath(path);
    }
  }

  render() {
    const { options, pathSelected, pathLoaded, loginFirst, userIdentified, uniquePath, languages, viaSso, fetchPathAfterLogin, loginFirstShowLoginForm, t } = this.props;
    const showInfoAndLoginDiv = (pathLoaded && loginFirst) || fetchPathAfterLogin;
    const rootSelectionOptions = (
      <RootOptionGroup
        options={this.getPathsAsOptions(options, viaSso)}
        onSelect={this.select}
        selected={pathSelected > -1 ? pathSelected : false}
        prefix={'rootSelection'}
        namespace={'roots'}
        key={'root-selection'}
      />
    );

    return (
      <div>
        <ServiceInfoBox />
        <div className="root-selection" style={{ backgroundImage: `url(${this.props.organizationBackgroundImageUrl})` }}>
          <Collapse in={!uniquePath} unmountOnExit>
            <Grid fluid className="intro-box">
              <Row>
                <Col className="intro-box-left" xs={12} sm={12} md={7} lg={7}>
                  <div>
                    <div className="box-header">
                      <h1 tabIndex={0} id={'root-selection-title'}>{t('root.title')}</h1>
                      <p>
                        <InnerHtmlContent content={t('root.info')} />
                      </p>
                      <p>
                        <InnerHtmlContent content={t('root.info2')} />
                      </p>
                      <LanguageSelector
                        languages={languages}
                      />
                    </div>
                  </div>
                </Col>
                <Col className="intro-box-right" xs={12} sm={12} md={5} lg={5}>
                  <div className="box-header">
                    {rootSelectionOptions}
                  </div>
                  <Button
                    onClick={this.props.setManagementOption}
                    bsStyle="link"
                    className="basic-action-link start-cancel-reservation-link center-block"
                  >
                    {viaSso ? t('booking:sectionTitles.history') : t('booking:cancelReservation.startCancelling')}
                  </Button>
                </Col>
              </Row>
            </Grid>
          </Collapse>
          { showInfoAndLoginDiv &&
          <Collapse in={uniquePath || !userIdentified} unmountOnExit>
            <div id="intro-box-login">
              <div>
                <hr hidden={uniquePath} />
                <MainLogin showLoginForm={!userIdentified && loginFirstShowLoginForm} triggerInitialScroll={this.props.triggerInitialScroll} />
              </div>
            </div>
          </Collapse>
          }
        </div>
      </div>
    );
  }
}

RootSelection.propTypes = {
  triggerInitialScroll: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  loadPath: PropTypes.func.isRequired,
  setManagementOption: PropTypes.func.isRequired,
  pathLoaded: PropTypes.bool.isRequired,
  pathSelected: PropTypes.number,
  organizationBackgroundImageUrl: PropTypes.string,
  loginFirst: PropTypes.bool.isRequired,
  loginFirstShowLoginForm: PropTypes.bool.isRequired,
  userIdentified: PropTypes.bool.isRequired,
  uniquePath: PropTypes.bool.isRequired,
  languages: PropTypes.array.isRequired,
  viaSso: PropTypes.bool.isRequired,
  fetchPathAfterLogin: PropTypes.bool.isRequired,
  googleAnalyticsTrackingId: PropTypes.string,
  goTo: PropTypes.string
};

RootSelection.defaultProps = {
  options: [],
  pathSelected: -1,
  organizationBackgroundImageUrl: '',
  pathLoaded: false,
  loginFirst: false,
  userIdentified: false,
  uniquePath: false,
  googleAnalyticsTrackingId: '',
  goTo: null
};

export default translate(['common', 'booking'], { wait: true })(RootSelection);



// WEBPACK FOOTER //
// ./src/containers/RootSelection/RootSelection.jsx